(function () {
  var PREORDER_TEXT = /pre\s*-?\s*order/i;
  var pendingForm = null;
  var pendingButton = null;

  function getProductFormFromButton(button) {
    if (!button) return null;

    var wrapper = button.closest('product-form');
    if (wrapper) return wrapper;

    var formId = button.getAttribute('form');
    if (formId) {
      var form = document.getElementById(formId);
      if (form) return form.closest('product-form');
    }

    var section = button.closest('[data-preorder-product="true"], section');
    return section ? section.querySelector('product-form[data-preorder-product="true"]') : null;
  }

  function getForm(wrapper) {
    return wrapper ? wrapper.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]') : null;
  }

  function getModal(wrapper) {
    var section = wrapper ? wrapper.closest('section') || wrapper.parentElement : null;
    return section ? section.querySelector('[data-preorder-modal]') : document.querySelector('[data-preorder-modal]');
  }

  function getSubmitButtons(wrapper) {
    if (!wrapper) return [];
    var section = wrapper.closest('section') || wrapper;
    return Array.prototype.slice.call(section.querySelectorAll('.product-form__submit, .main-product-atc, button[name="add"]'));
  }

  function hasGloboPreorderSignal(wrapper) {
    if (!wrapper || wrapper.dataset.preorderProduct === 'true') return false;
    if (wrapper.closest('.product-card-wrapper, .card-wrapper')) return false;
    if (!wrapper.classList.contains('main-product-form') && wrapper.dataset.main !== 'true') return false;

    var buttons = getSubmitButtons(wrapper);
    return buttons.some(function (button) {
      return PREORDER_TEXT.test(button.textContent || '');
    });
  }

  function getProductTitle(wrapper) {
    var section = wrapper ? wrapper.closest('section') : null;
    var heading = section ? section.querySelector('h1, .product__title, [class*="title" i]') : null;
    return heading ? heading.textContent.trim() : 'This item';
  }

  function createPreorderModal(wrapper) {
    var section = wrapper ? wrapper.closest('section') : null;
    if (!section || section.querySelector('[data-preorder-modal]')) return;

    var title = getProductTitle(wrapper);
    var container = document.createElement('div');
    container.className = 'preorder-acknowledgement preorder-acknowledgement--dynamic';
    container.setAttribute('data-preorder-acknowledgement', '');
    container.innerHTML = [
      '<div class="preorder-acknowledgement__notice">',
      '<span class="preorder-acknowledgement__icon" aria-hidden="true">!</span>',
      '<div><strong>Pre-order item</strong>',
      '<p>This item is not ready to ship immediately. We will send it once preorder stock arrives.</p></div>',
      '</div>',
      '<div class="preorder-acknowledgement__modal" data-preorder-modal aria-hidden="true" hidden>',
      '<div class="preorder-acknowledgement__backdrop" data-preorder-close></div>',
      '<div class="preorder-acknowledgement__dialog" role="dialog" aria-modal="true" aria-labelledby="DynamicPreorderAcknowledgement-title">',
      '<button class="preorder-acknowledgement__close" type="button" data-preorder-close aria-label="Close preorder notice">&times;</button>',
      '<p class="preorder-acknowledgement__eyebrow">Before you add this</p>',
      '<h2 id="DynamicPreorderAcknowledgement-title">This is a pre-order item</h2>',
      '<p class="preorder-acknowledgement__copy"><strong>' + title + '</strong> is not ready to ship immediately. Your order will ship once preorder stock arrives.</p>',
      '<label class="preorder-acknowledgement__checkbox"><input type="checkbox" data-preorder-checkbox><span>I understand this is a pre-order and may take longer than in-stock items.</span></label>',
      '<p class="preorder-acknowledgement__error" data-preorder-error hidden>Please tick the box to continue.</p>',
      '<button class="button button--full-width preorder-acknowledgement__confirm" type="button" data-preorder-confirm>I understand, add to cart</button>',
      '<button class="preorder-acknowledgement__cancel" type="button" data-preorder-close>Go back</button>',
      '</div></div>'
    ].join('');

    wrapper.insertAdjacentElement('afterend', container);
  }

  function ensureAcknowledgementInput(wrapper) {
    var form = getForm(wrapper);
    if (!form || form.querySelector('[data-preorder-acknowledgement-input]')) return;

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Pre-order acknowledgement]';
    input.value = 'Customer confirmed this is a pre-order item before adding to cart';
    input.setAttribute('data-preorder-acknowledgement-input', '');
    input.disabled = true;
    form.appendChild(input);
  }

  function activatePreorderWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.preorderProduct === 'true') return;

    wrapper.dataset.preorderProduct = 'true';
    getSubmitButtons(wrapper).forEach(function (button) {
      button.setAttribute('data-preorder-submit', 'true');
    });
    ensureAcknowledgementInput(wrapper);
    createPreorderModal(wrapper);
  }

  function scanForGloboPreorders(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wrappers = [];

    if (scope.matches && scope.matches('product-form')) wrappers.push(scope);
    scope.querySelectorAll('product-form').forEach(function (wrapper) {
      wrappers.push(wrapper);
    });

    wrappers.forEach(function (wrapper) {
      if (hasGloboPreorderSignal(wrapper)) activatePreorderWrapper(wrapper);
    });
  }

  function isConfirmed(wrapper) {
    return wrapper && wrapper.dataset.preorderConfirmed === 'true';
  }

  function setAcknowledgement(wrapper, enabled) {
    var input = wrapper ? wrapper.querySelector('[data-preorder-acknowledgement-input]') : null;
    if (!input) return;
    input.disabled = !enabled;
  }

  function openModal(wrapper) {
    var modal = getModal(wrapper);
    if (!modal) return false;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('preorder-acknowledgement-open');

    var checkbox = modal.querySelector('[data-preorder-checkbox]');
    var error = modal.querySelector('[data-preorder-error]');
    if (checkbox) checkbox.checked = false;
    if (error) error.hidden = true;

    window.setTimeout(function () {
      var focusTarget = modal.querySelector('[data-preorder-checkbox]') || modal.querySelector('[data-preorder-confirm]');
      if (focusTarget) focusTarget.focus();
    }, 20);

    return true;
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('preorder-acknowledgement-open');
  }

  function shouldIntercept(wrapper) {
    return wrapper && wrapper.dataset.preorderProduct === 'true' && !isConfirmed(wrapper);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-preorder-submit="true"], .product-form__submit, .main-product-atc');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var wrapper = getProductFormFromButton(button);
    if (!shouldIntercept(wrapper)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    pendingForm = wrapper;
    pendingButton = button;
    openModal(wrapper);
  }, true);

  document.addEventListener('submit', function (event) {
    var wrapper = event.target.closest('product-form[data-preorder-product="true"]');
    if (!shouldIntercept(wrapper)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    pendingForm = wrapper;
    pendingButton = wrapper.querySelector('[data-preorder-submit="true"], .product-form__submit');
    openModal(wrapper);
  }, true);

  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-preorder-close]');
    if (close) {
      closeModal(close.closest('[data-preorder-modal]'));
      pendingForm = null;
      pendingButton = null;
      return;
    }

    var confirm = event.target.closest('[data-preorder-confirm]');
    if (!confirm) return;

    var modal = confirm.closest('[data-preorder-modal]');
    var checkbox = modal.querySelector('[data-preorder-checkbox]');
    var error = modal.querySelector('[data-preorder-error]');

    if (!checkbox || !checkbox.checked) {
      if (error) error.hidden = false;
      return;
    }

    var wrapper = pendingForm || document.querySelector('product-form[data-preorder-product="true"]');
    var form = getForm(wrapper);
    if (!wrapper || !form) return;

    wrapper.dataset.preorderConfirmed = 'true';
    setAcknowledgement(wrapper, true);
    closeModal(modal);

    if (pendingButton && pendingButton.type !== 'submit') {
      pendingButton.click();
    } else if (form.requestSubmit) {
      form.requestSubmit(pendingButton && pendingButton.type === 'submit' ? pendingButton : undefined);
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    window.setTimeout(function () {
      if (wrapper) wrapper.dataset.preorderConfirmed = 'false';
      setAcknowledgement(wrapper, false);
      pendingForm = null;
      pendingButton = null;
    }, 1200);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-preorder-modal]:not([hidden])').forEach(closeModal);
    pendingForm = null;
    pendingButton = null;
  });

  function startGloboWatcher() {
    scanForGloboPreorders(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target && mutation.target.nodeType === Node.ELEMENT_NODE) {
          scanForGloboPreorders(mutation.target.closest('section') || mutation.target);
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) scanForGloboPreorders(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGloboWatcher);
  } else {
    startGloboWatcher();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanForGloboPreorders(event.target);
  });
})();
